import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ButtonModifier } from "../../../components";
import { ShowTableRabPekerjaanChild } from "../../../components/ShowTable";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Pagination,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilRabPekerjaan = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idRabPekerjaan } = useParams();
  // Data Rab
  const [noRab, setNoRab] = useState("");
  const [tanggalRab, setTanggalRab] = useState("");
  // Data Pekerjaan
  const [noRabPekerjaan, setNoRabPekerjaan] = useState("");
  const [namaRabPekerjaan, setNamaRabPekerjaan] = useState("");
  const [jumlah, setJumlah] = useState("0");
  const [satuan, setSatuan] = useState("");
  const [keteranganRabPekerjaan, setKeteranganRabPekerjaan] = useState("");

  const [rabPekerjaanChildsPagination, setRabPekerjaanChildsPagination] =
    useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN";
  // let isEditable = isEditableManager;
  let isEditable = true;

  const [searchTerm, setSearchTerm] = useState("");
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getRabPekerjaanById();
  }, [page]);

  const getRabPekerjaanById = async () => {
    if (id) {
      setLoading(true);
      const response = await postRequest(
        `/rabPekerjaans/${idRabPekerjaan}`,
        {},
        navigate,
        dispatch
      );
      // Data Rab
      setNoRab(response.data.rab.noRab);
      setTanggalRab(formatDate(response.data.rab.tanggalDpRab));

      // Data Pekerjaan
      setNoRabPekerjaan(response.data.noRabPekerjaan);
      setNamaRabPekerjaan(response.data.namaRabPekerjaan);
      setJumlah(response.data.jumlah.toLocaleString("en-US"));
      setSatuan(response.data.satuan);
      setKeteranganRabPekerjaan(response.data.keteranganRabPekerjaan);

      const response2 = await postRequest(
        `/rabPekerjaanChildsByRabPekerjaanPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        { rabPekerjaanId: idRabPekerjaan },
        navigate,
        dispatch
      );
      setRabPekerjaanChildsPagination(response2.data.rabPekerjaanChilds);
      setPage(response2.data.page);
      setPages(response2.data.totalPage);
      setRows(response2.data.totalRows);
      setLoading(false);
    }
  };

  const deleteRabPekerjaan = async (id) => {
    setLoading(true);
    // Delete Rab Pekerjaan
    await postRequest(
      `/deleteRabPekerjaan/${idRabPekerjaan}`,
      {
        rabId: id,
        noRabPekerjaan: noRabPekerjaan,
      },
      navigate,
      dispatch
    );
    setLoading(false);
    navigate(`/daftarRab/rab/${id}`);
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>Detail Rab Pekerjaan</h5>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate(`/daftarRab/rab/${id}`)}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={deleteButtonContainer}>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`Hapus Data`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {`Yakin ingin menghapus data ${namaRabPekerjaan}?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => deleteRabPekerjaan(id)}>Ok</Button>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
        {isEditable && (
          <ButtonModifier
            id={id}
            kode={"test"}
            addLink={`/daftarRab/rab/${id}/${idRabPekerjaan}/tambahRabPekerjaanChild`}
            editLink={`/daftarRab/rab/${id}/${idRabPekerjaan}/edit`}
            deleteUser={deleteRabPekerjaan}
            nameUser={noRab}
          />
        )}
      </Box>
      <hr />
      <Card>
        <Card.Header>Detail Pekerjaan</Card.Header>
        <Card.Body>
          <Form>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        No. RAB :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={noRab}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Tanggal :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={tanggalRab}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        No. Pekerjaan :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={noRabPekerjaan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={namaRabPekerjaan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Jumlah :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={jumlah}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Satuan :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={satuan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Keterangan :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          as="textarea"
                          rows={4}
                          value={keteranganRabPekerjaan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      <Box sx={tableContainer}>
        <ShowTableRabPekerjaanChild
          page={page}
          limit={limit}
          id={id}
          idRabPekerjaan={idRabPekerjaan}
          currentPosts={rabPekerjaanChildsPagination}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilRabPekerjaan;

const deleteButtonContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
